"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgClock(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.75C6.338 1.75 1.75 6.34 1.75 12S6.338 22.25 12 22.25c5.66 0 10.25-4.59 10.25-10.25S17.66 1.75 12 1.75zM.25 12C.25 5.512 5.51.25 12 .25 18.488.25 23.75 5.512 23.75 12S18.488 23.75 12 23.75C5.51 23.75.25 18.488.25 12zm11.5-8a.75.75 0 01.75.75v6.94l3.78 3.78a.75.75 0 11-1.06 1.06l-4-4a.749.749 0 01-.21-.655.76.76 0 01-.01-.125v-7a.75.75 0 01.75-.75z",
    fill: "inherit"
  }));
}

var _default = SvgClock;
exports.default = _default;